/**
 * 功能: 报告信息录入导航
 */
<template lang="pug">
  el-menu.el-menu-demo(:default-active="currentIndex" mode="horizontal" router)
    el-menu-item(index="6" :route="{name: 'EditReportLog', query: {id: mainId}}") 更新记录
    //- el-menu-item(index="7" :route="{name: 'EditReportPDF', query: {id: mainId}}") PDF
    el-menu-item(index="1" :route="{name: 'EditReportBrief', query: {id: mainId}}") 报告摘要
    el-menu-item(index="2" :route="{name: 'EditReportGlossary', query: {id: mainId }}" :disabled="!allowToSubObject") 名词解释
    el-menu-item(index="3" :route="{name: 'EditReportOutline', query: {id: mainId }}" :disabled="!allowToSubObject") 编辑目录
    el-menu-item(v-if="kind==0" index="4" :route="{name: 'EditReportContent', query: {id: mainId }}" :disabled="!allowToSubObject") 编辑内容
    el-menu-item(v-if="kind==1" index="5" :route="{name: 'EditReportSlide', query: {id: mainId }}" :disabled="!allowToSubObject") 编辑内容
    span.span.one-ellipsis {{title}}
</template>

<script>
export default {
  props: {
    mainId: [Number, String],
    title: {
      type: String
    },
    kind: [Number, String],
    status: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      mapIndex: [
        { index: '1', name: 'EditReportBrief' },
        { index: '2', name: 'EditReportGlossary' },
        { index: '3', name: 'EditReportOutline' },
        { index: '4', name: 'EditReportContent' },
        { index: '5', name: 'EditReportSlide' },
        { index: '6', name: 'EditReportLog' },
        { index: '7', name: 'EditReportPDF' }
      ]
    }
  },
  computed: {
    // 必须初始化值 不然监听不到数据变化
    // 判断是否能够进行导航切换
    allowToSubObject () {
      if (this.status >= 1) {
        return false
      }
      return this.mainId !== 0
    },
    // 判断当前哪个导航属于激活状态
    currentIndex () {
      return this.mapIndex.filter(item => item.name === this.$route.name)[0].index
    }
  },
  methods: { }
}
</script>

<style lang="scss" scoped>
.el-menu {
  height: 40px;
  margin-bottom: 8px;
  white-space: nowrap;
  min-width: 500px;
  .el-menu-item {
    height: 40px;
    line-height: 40px;
  }
}
.span{
  font-size:0.94rem;
  font-weight: bold;
  padding-left:20%;
  line-height: 2.6;
  display: inline-block;
  width: 65%;
}
</style>
